import { useState } from "react";
import { Button } from "./ui/button";
// import muslifinLogo from "figma:asset/1cfa254f924382aa7bbe3ac0ab6849ad511991aa.png";
import { ContactForm } from "./ContactForm";
import { ApplyNowForm } from "./ApplyNowForm";
import { Menu, X } from "lucide-react";

interface HeaderProps {
  currentPage: string;
  setCurrentPage: (page: string) => void;
}

export function Header({ currentPage, setCurrentPage }: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handlePageChange = (page: string) => {
    setCurrentPage(page);
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Tagline */}
          <div 
            className="flex items-center cursor-pointer"
            onClick={() => handlePageChange('home')}
          >
            <div className="flex flex-col items-center">
              <div className="flex items-center">
                <img 
                  src="/assets/muslifin-logo-white.png.png" 
                  alt="MusliFin" 
                  className="h-10 w-auto mb-1"
                  onError={(e) => {
                    const img = e.currentTarget as HTMLImageElement;
                    const span = img.nextElementSibling as HTMLElement;
                    img.style.display = 'none';
                    span.style.display = 'block';
                  }}
                />
                <span 
                  className="h-10 text-2xl font-bold text-[#004aad] mb-1 hidden"
                  style={{ display: 'none' }}
                >
                  MusliFin
                </span>
              </div>
              <div className="text-xs text-gray-600 hidden sm:block text-center">
                Your Muslim Financing Partner
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <nav className="flex space-x-8">
              <button
                onClick={() => setCurrentPage('home')}
                className={`transition-colors hover:text-[#004aad] ${
                  currentPage === 'home' ? 'text-[#004aad]' : 'text-gray-600'
                }`}
              >
                Home
              </button>
              <button
                onClick={() => setCurrentPage('dealerships')}
                className={`transition-colors hover:text-[#004aad] ${
                  currentPage === 'dealerships' ? 'text-[#004aad]' : 'text-gray-600'
                }`}
              >
                For Dealerships
              </button>
              <button
                onClick={() => setCurrentPage('investors')}
                className={`transition-colors hover:text-[#004aad] ${
                  currentPage === 'investors' ? 'text-[#004aad]' : 'text-gray-600'
                }`}
              >
                For Investors
              </button>
              <ContactForm>
                <button className="transition-colors hover:text-[#004aad] text-gray-600">
                  Contact
                </button>
              </ContactForm>
            </nav>

            <ApplyNowForm 
              asModal={true}
              triggerButton={
                <Button className="bg-[#004aad] hover:bg-[#003a8a] text-white px-6">
                  Express Interest
                </Button>
              }
            />
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-4">
            <ContactForm>
              <button className="text-gray-600 hover:text-[#004aad] transition-colors">
                Contact
              </button>
            </ContactForm>
            <button
              onClick={toggleMobileMenu}
              className="text-gray-600 hover:text-[#004aad] transition-colors"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-100 py-4">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => handlePageChange('home')}
                className={`text-left transition-colors hover:text-[#004aad] ${
                  currentPage === 'home' ? 'text-[#004aad]' : 'text-gray-600'
                }`}
              >
                Home
              </button>
              <button
                onClick={() => handlePageChange('dealerships')}
                className={`text-left transition-colors hover:text-[#004aad] ${
                  currentPage === 'dealerships' ? 'text-[#004aad]' : 'text-gray-600'
                }`}
              >
                For Dealerships
              </button>
              <button
                onClick={() => handlePageChange('investors')}
                className={`text-left transition-colors hover:text-[#004aad] ${
                  currentPage === 'investors' ? 'text-[#004aad]' : 'text-gray-600'
                }`}
              >
                For Investors
              </button>
              <ApplyNowForm 
                asModal={true}
                triggerButton={
                  <Button className="bg-[#004aad] hover:bg-[#003a8a] text-white w-full">
                    Express Interest
                  </Button>
                }
              />
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}